import { Link } from "react-router-dom";
import { Instagram, Linkedin, BookOpen, Globe, Lock } from "lucide-react";
import { Logo } from "@/components/Logo";

const SOCIALS = [
  { label: "LinkedIn", href: "https://www.linkedin.com/in/angel-garcia-6413b33a0", icon: Linkedin, testid: "footer-linkedin" },
  { label: "Instagram", href: "https://www.instagram.com/street2strategyconsulting", icon: Instagram, testid: "footer-instagram" },
  { label: "Amazon Author Page", href: "https://www.amazon.com/author/4rmdastreets2strategist", icon: BookOpen, testid: "footer-amazon" },
  { label: "Beacons", href: "https://beacons.ai/4rmdastreets2strategist", icon: Globe, testid: "footer-beacons" },
];

export default function Footer() {
  return (
    <footer className="relative border-t border-white/10 bg-[#0D0E11] grain overflow-hidden" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 pt-20 pb-10">
        <div className="flex flex-col lg:flex-row justify-between gap-12">
          <div className="max-w-sm">
            <Logo />
            <p className="mt-5 text-sm text-[#9CA3AF] leading-relaxed">
              Trauma-informed leadership development for adult and juvenile corrections — built from lived experience, adapted from the book <span className="text-[#F3F4F6]">The Hood's Curriculum</span>.
            </p>
            <div className="mt-6 flex gap-3">
              {SOCIALS.map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  title={s.label}
                  className="w-10 h-10 rounded-full border border-white/10 flex items-center justify-center text-[#9CA3AF] hover:text-amber-500 hover:border-amber-500/50 transition-colors"
                  data-testid={s.testid}
                >
                  <s.icon size={16} />
                </a>
              ))}
            </div>
          </div>

          <div className="flex gap-16">
            <div>
              <div className="font-mono-tactical text-[11px] tracking-[0.2em] text-[#6B7280] mb-4">PROGRAM</div>
              <ul className="space-y-3 text-sm text-[#9CA3AF]">
                <li><a href="#program" className="hover:text-amber-500 transition-colors">The 5 Modules</a></li>
                <li><a href="#impact" className="hover:text-amber-500 transition-colors">Impact</a></li>
                <li><a href="#speaking" className="hover:text-amber-500 transition-colors">Speaking</a></li>
                <li><a href="#inquiry" className="hover:text-amber-500 transition-colors">Book a Training</a></li>
              </ul>
            </div>
            <div>
              <div className="font-mono-tactical text-[11px] tracking-[0.2em] text-[#6B7280] mb-4">COMPANY</div>
              <ul className="space-y-3 text-sm text-[#9CA3AF]">
                <li><a href="#manifesto" className="hover:text-amber-500 transition-colors">Angel's Story</a></li>
                <li><a href="#book" className="hover:text-amber-500 transition-colors">The Book</a></li>
                <li>
                  <Link to="/admin/login" className="inline-flex items-center gap-1.5 hover:text-amber-500 transition-colors" data-testid="footer-admin-link">
                    <Lock size={12} /> Admin Portal
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-16 select-none pointer-events-none" aria-hidden="true">
          <div className="font-display font-extrabold text-[22vw] lg:text-[16vw] leading-[0.8] text-white/[0.04] tracking-tighter whitespace-nowrap">
            S2S
          </div>
        </div>

        <div className="mt-4 pt-6 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-3 font-mono-tactical text-[10px] tracking-[0.15em] text-[#6B7280]">
          <span>© {new Date().getFullYear()} STREET2STRATEGY CONSULTING</span>
          <span>THE HOOD'S CURRICULUM — SUCCESS IS A MINDSET</span>
        </div>
      </div>
    </footer>
  );
}
